import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'

import FakeInput from '../components/FakeInput'

const DebitBalance: FC<{ FormName: string }> = ({ FormName }) => {
  const balance: number = useSelector((state) => formValueSelector(FormName)(state, 'DebitAccBalance') || 0)

  return <FakeInput>{balance.toFixed(2)}</FakeInput>
}

export default DebitBalance
